import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/ElectricityCheckoutDataProvider";
import BaseDeliveryForm from "./BaseDeliveryForm";
import InvoiceAddress from "./InvoiceAddress";

const StepDeliveryAddress = () => {
    const dataContext = useContext(DataContext);
    const { useInvoiceAddress } = dataContext.data;

    return (
        <React.Fragment>
            <BaseDeliveryForm />
            {useInvoiceAddress === 1 && <InvoiceAddress />}
        </React.Fragment>
    );
};

export default StepDeliveryAddress;
